import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
import { Stack, styled, Typography } from '@mui/material';

interface Props {
	list: string[];
}

interface PropsChildren {
	children?: PropTypes.ReactElementLike | PropTypes.ReactElementLike[];
}

interface PropsChildrenTitle extends PropsChildren {
	title: string;
}

export function ListWrap(props: PropsChildren) {
	return <Stack spacing={1}>{props.children}</Stack>;
}

export function ListHeader(props: PropsChildrenTitle) {
	return <Typography variant="boldBody1">{props.title}</Typography>;
}

export function ListHeader2(props: PropsChildrenTitle) {
	return <Typography variant="h3">{props.title}</Typography>;
}

export function ListHeaderWithActions(props: PropsChildrenTitle) {
	return (
		<Box flexDirection="row" display="flex">
			<Box flex={1}>
				<Typography variant="h3">{props.title}</Typography>
			</Box>
			<Stack sx={{ textAlign: 'right', '& img': { cursor: 'pointer' } }} spacing={1} direction="row">
				{props.children}
			</Stack>
		</Box>
	);
}

export function SimpleList(props: Props) {
	return (
		<Stack>
			{props.list.map((text, i) => (
				<Typography key={text + String(i)} variant="body3">
					{text}
				</Typography>
			))}
		</Stack>
	);
}

export const ListTables = styled(Stack)((props) => ({
	[props.theme.breakpoints.down('sm')]: {
		'& .HeaderPage2': {
			textAlign: 'center',
			color: props.theme.palette.root.titleGreen,
			'& .MuiTypography-root': {
				fontSize: '1.2rem',
			},
		},
		'& .simpleTable .MuiTableRow-root:first-of-type': {
			borderColor: props.theme.palette.root.titleGreen,
		},
	},
}));
